
import { getServiceEndpoints } from "../../environments/services";
import { IAPIDefinitions } from "../APIDefs";
import { Dispatch } from "react";
import { resetCart, setDietaryTags, setExtras, setGroupInfo, setGroupName, setMenuItems, setMenuItemsAsExtra, setPreferences, setSelectedMenuType, setTaxItems, setVenue } from "../../redux/actions/consumer.actions";
import { setCurrencies, setCurrency, setLanguage } from "../../redux/actions/localization";
import { generateTradingTimesObject, ITradingTimes } from "../../utils/tradingTimesObject";
import { groupVenueType } from "../../interfaces/GroupInfo.type";

export enum APIConsumer {
    consumerVenue = 'consumerVenue',
    consumerGroup = 'consumerGroup',
    consumerMenu = 'consumerMenu',
    consumerOrders = 'consumerOrders',
    consumerLatestOrder = 'consumerLatestOrder'
}

function getFullURL() {
    const stage = process.env.REACT_APP_STAGE;
    const overwriteHost = process.env.REACT_APP_SERVICE_ENDPOINT;
    if (!stage) {
        return;
    }
    let services = getServiceEndpoints(stage, overwriteHost);
    return services['consumerAPI'];
}

const url = getFullURL();

export const consumerAPIDefs: IAPIDefinitions = {};


consumerAPIDefs[APIConsumer.consumerVenue] = {
    baseURL: url,
    defaultURL: `/venues/`,
    dataStorage: {
        defaultDataKey: 'Venue',
        selectorKey: () => { return 'Venue'; },
        dispatchFunction: (dispatch: Dispatch<any>, result: any, args) => {
            console.log("args", { args });
            if (Array.isArray(args) && !args[0]) {
                dispatch(resetCart());
                dispatch(setLanguage(result.language_iso.toUpperCase()));
            }
            const currencyObj = {
                id: result.currency_id,
                iso_code: result.currency_iso,
                english_name: result.currency_name,
                symbol: result.currency_symbol,
            };
            dispatch(setSelectedMenuType(null));
            dispatch(setCurrencies([currencyObj]));
            dispatch(setCurrency(currencyObj.id));
            dispatch(setVenue(result));
        }
    },
    GET: {}
};

consumerAPIDefs[APIConsumer.consumerGroup] = {
    baseURL: url,
    defaultURL: `/venue-groups/`,
    dataStorage: {
        defaultDataKey: 'Group',
        selectorKey: () => { return 'Group'; },
        dispatchFunction: (dispatch: Dispatch<any>, result: any, args) => {
            console.log({ result });
            dispatch(setLanguage(result.group_language_iso.toUpperCase()));
            dispatch(setGroupName(result.group_name_public));
            const venues = result.group_venues;
            const group_venues = venues.map((groupV: groupVenueType) => {
                return {
                    ...groupV,
                    trading_times: generateTradingTimesObject(
                        groupV.venue_trading_times as ITradingTimes[]
                    ),
                };
            });
            const groupInfo = {
                ...result,
                group_venues,
            };
            dispatch(setGroupInfo(groupInfo));
            dispatch(setSelectedMenuType(null));
        }
    },
    GET: {}
};

consumerAPIDefs[APIConsumer.consumerMenu] = {
    baseURL: url,
    defaultURL: `/menu-items/`,
    dataStorage: {
        defaultDataKey: 'MenuItem',
        selectorKey: () => { return 'MenuItem'; },
        dispatchFunction: (dispatch: Dispatch<any>, result: any, args): void => {
            dispatch(setMenuItems({
                menuItems: result.menu_items,
                categories: result.subcategories,
            }));
            dispatch(setPreferences(result.menu_item_preferences));
            dispatch(setExtras(result.menu_item_extra_groups));
            dispatch(setMenuItemsAsExtra(result.menu_items_as_extras));
            dispatch(setDietaryTags(result.dietary_tags));
            if (result.taxes) {
                dispatch(setTaxItems(result.taxes));
            }
        }
    },
    GET: {}
};

consumerAPIDefs[APIConsumer.consumerOrders] = {
    baseURL: url,
    defaultURL: '/orders',
    GET: {}
};

consumerAPIDefs[APIConsumer.consumerLatestOrder] = {
    baseURL: url,
    defaultURL: '/orders-latest',
    GET: {}
};